/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMW } from "./GMW";
import { GMWFromJSON, GMWFromJSONTyped, GMWToJSON, GMWToJSONTyped } from "./GMW";

/**
 *
 * @export
 * @interface ApiGmwGmwsList200Response
 */
export interface ApiGmwGmwsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmwGmwsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGmwsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGmwsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMW>}
   * @memberof ApiGmwGmwsList200Response
   */
  results: Array<GMW>;
}

/**
 * Check if a given object implements the ApiGmwGmwsList200Response interface.
 */
export function instanceOfApiGmwGmwsList200Response(
  value: object
): value is ApiGmwGmwsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmwGmwsList200ResponseFromJSON(json: any): ApiGmwGmwsList200Response {
  return ApiGmwGmwsList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwGmwsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGmwsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMWFromJSON),
  };
}

export function ApiGmwGmwsList200ResponseToJSON(json: any): ApiGmwGmwsList200Response {
  return ApiGmwGmwsList200ResponseToJSONTyped(json, false);
}

export function ApiGmwGmwsList200ResponseToJSONTyped(
  value?: ApiGmwGmwsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMWToJSON),
  };
}
